import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogContentComponent } from 'src/app/pages/claims/components/dialog-content/dialog-content.component';
import { IDocument, IDocumentDisplay } from '../../models/claim.interface';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ClaimService } from 'src/app/services/claim.service';
import { ALL_SPECIAL_CHARACTERS } from '../../regex-patterns';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomToastComponent } from 'src/app/pages/claims-custom/tupss/tupss-edit/components/custom-toast/custom-toast.component';
import { LoginService } from 'src/app/services/login.service';
import { UserService } from 'src/app/services/user.service';
import { ALLOWED_DOC_TYPES } from 'src/config/app-config';

@Component({
  selector: 'upsc-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss']
})
export class DocumentUploadComponent implements OnInit {
  //0-Loss; 1-Damage; 2-Missing Content; 3-Late Delivery
  // @Input() claimReason: string;
  // @Input() claimNumber: string;
  @Input() uploadParams: BehaviorSubject<{ [key: string]: any }>;
  @Input() postFnolDoc: string = 'false';
  @Output() uploadStatus: EventEmitter<any> = new EventEmitter();
  @Input() proofOfValue: string = '0';
  @Input() isUploadDisabled: boolean = false;

  docRequest: IDocument = {};
  claimReason: string;
  claimNumber: string;
  isCanadaUser: boolean;
  isCargo: boolean;
  isDocumentMissing: boolean;
  policy;
  highlightRed: boolean;

  //File Upload
  fileToUpload: File = null;
  errorList = [];
  removeDocumentError: boolean = false;

  //buckets
  invoices = [];
  photos = [];
  others = [];

  // bundled claim variables;
  isBundledClaim: boolean = false;

  cachedDocuments: {
    bundledClaimFlow: any[];
    normalClaimFlow: any[];
  } = {
      bundledClaimFlow: [],
      normalClaimFlow: []
    };


  isInternalUser: boolean = false;
  app_role_id: number = 0;
  canViewDigitalWallet: boolean = false;

  constructor(
    public dialog: MatDialog,
    private claimService: ClaimService,
    private snackBar: MatSnackBar,
    private loginService: LoginService,
    private userService: UserService
  ) { }

  ngOnInit(): void {

    try {
      this.isInternalUser = this.userService.isInternalUser();
      this.app_role_id = this.userService.getUserInfo().app_role_id;

      if (this.isInternalUser && (this.app_role_id === 7 || this.app_role_id === 9)) {
        this.canViewDigitalWallet = true;
      }
    } catch {

    }

    try {
      this.isBundledClaim = this.userService.isBundledClaimUser();
    } catch {

    }

    this.uploadParams.subscribe(params => {
      if (params) {
        if (params['claimReason']) {
          this.claimReason = params['claimReason'];
          this.updateDocumentStatus();
        }
        if (params['isDocumentMissing'] != undefined) {
          this.isDocumentMissing = params['isDocumentMissing'];
        }
        if (params['claimNumber']) {
          this.claimNumber = params['claimNumber'];
        }

        if (params['highlightRed']) {
          this.highlightRed = params['highlightRed'];
        }
      }
    });
    Object.assign(this, JSON.parse(sessionStorage.getItem('documentUploadParams')));
    Object.assign(this, JSON.parse(sessionStorage.getItem('documentUploadedFiles')));
    this.policy = this.loginService.getPolicyDetails();
    this.updateDocumentStatus();
  }

  //Input: list of documents
  //Output: list of documents, and whether or not they should be uploaded, and reasoning for that.
  //Checks for things such as filename, filesize, max # of documents per bucket
  preliminaryDocumentChecks(listOfDocs, bucket): any[] {
    let checkedDocumentList = [];
    // let invoiceBucketLength = this.invoices.length;
    // let photoBucketLength = this.photos.length;
    // // let otherBucketLength = this.others.length;
    // let tempInvoiceBucketTotal = invoiceBucketLength;
    // let tempPhotoBucketLength = photoBucketLength;
    // let tempOtherBucketLength = otherBucketLength;
    for (let i = 0; i < listOfDocs.length; i++) {
      const file = listOfDocs.item(i);
      let object = { file: file, shouldBeUploaded: true, reasonToNotUpload: '' };
      if (file.name.length > 80) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'The file name exceeds the maximum limit of 70 characters';
      }
      let fileNameParts = file.name.split('.');
      if (fileNameParts.length <= 1 || ALLOWED_DOC_TYPES.indexOf(fileNameParts[fileNameParts.length - 1].toLowerCase()) < 0) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'The file type is not supported';
      }
      if (file.size >= 10000000) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'File size exceeds 7MB';
      }
      if (bucket == 'ONL-Invoice' && this.invoices.find(x => x.file.name == file.name)) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'Duplicate files are not allowed';
      }
      if (bucket == 'ONL-Photo' && this.photos.find(x => x.file.name == file.name)) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'Duplicate files are not allowed';
      }
      if (bucket == 'ONL-Other' && this.others.find(x => x.file.name == file.name)) {
        object.shouldBeUploaded = false;
        object.reasonToNotUpload = 'Duplicate files are not allowed';
      }

      //The commented out code is for 10 max files per bucket. Business has decided to REMOVE the limit.

      // if (bucket == 'ONL-Invoice' && (invoiceBucketLength >= 10 || tempInvoiceBucketTotal >= 10)) {
      //   object.shouldBeUploaded = false;
      //   object.reasonToNotUpload = 'Maximum number of files reached';
      // }
      // if (bucket == 'ONL-Photo' && (photoBucketLength >= 10 || tempPhotoBucketLength >= 10)) {
      //   object.shouldBeUploaded = false;
      //   object.reasonToNotUpload = 'Maximum number of files reached';
      // }
      // if (bucket == 'ONL-Other' && (otherBucketLength >= 10 || tempOtherBucketLength >= 10)) {
      //   object.shouldBeUploaded = false;
      //   object.reasonToNotUpload = 'Maximum number of files reached';
      // }
      // if (bucket == 'ONL-Invoice' && object.shouldBeUploaded) {
      //   tempInvoiceBucketTotal+=1;
      // }
      // if (bucket == 'ONL-Photo' && object.shouldBeUploaded) {
      //   tempPhotoBucketLength+=1;
      // }
      // if (bucket == 'ONL-Other' && object.shouldBeUploaded) {
      //   tempOtherBucketLength+=1;
      // }
      checkedDocumentList.push(object)
    }
    return checkedDocumentList;
  }

  //First method that is called when documents are attempting to be uploaded.
  //Basically the upload document controller
  //Directs the file to be checked if it can be uploaded, and then attempts upload.
  uploadDocument(files: FileList, bucket: string, event?): void {
    if (!this.claimNumber) {
      Object.assign(this, JSON.parse(sessionStorage.getItem('documentUploadParams')));
      Object.assign(this, JSON.parse(sessionStorage.getItem('documentUploadedFiles')));
    }
    this.clearDocumentErrors();
    let checkedDocumentsList = this.preliminaryDocumentChecks(files, bucket);

    if (event?.target?.value) {
      event.target.value = null;  //This is required in the scenario the user tries to upload (A), it fails, and then they try to upload (A) again.
    }

    //Now try to upload documents
    if (checkedDocumentsList && checkedDocumentsList.length > 0) {
      for (let i = 0; i < checkedDocumentsList.length; i++) {
        if (checkedDocumentsList[i].shouldBeUploaded) {
          this.generateTokenAndUploadFile(checkedDocumentsList[i].file, bucket);
        } else {
          this.errorList.push({ filename: checkedDocumentsList[i].file.name, error: checkedDocumentsList[i].reasonToNotUpload });
        }
      }
    }
  }

  generateTokenAndUploadFile(file, bucket) {
    if (!this.claimNumber) {
      let draftClaimSession = JSON.parse(sessionStorage.getItem('claim'));
      if (draftClaimSession) {
        this.claimNumber = draftClaimSession.claimNumber;
      }
    }
    this.claimService.generateUploadToken().subscribe(
      data => {
        this.docRequest = {
          sessionID: data,
          claimNumber: this.claimNumber,
          name: this.formatFileName(file),
          docUID: '001',
          documentType: 'letter_received',
          securityType: 'unrestricted',
          status: 'approved',
          postFnolDoc: this.postFnolDoc,
          description: bucket,
          mimeType: file.name.endsWith('.msg') ? 'application/vnd.ms-outlook' :  file.name.toLowerCase().endsWith('.heic') ? 'image/heic' :  file.type
        }

        let formData: FormData = new FormData();
        formData.append('documentUploadRequest', JSON.stringify(this.docRequest));
        formData.append('file', file, this.formatFileName(file));
        // formData.append('policyNumber', this.policy.policyNumber); //Not including this until GW and MS are ready for it

        this.claimService.uploadDocument(formData).subscribe(
          response => {
            if (response.publicID) {
              // Add the file to the appropriate bucket
              if (bucket === "ONL-Invoice") {
                if (this.isBundledClaim) {
                  let documentObj = { file: file, publicID: response.publicID, bucket: bucket, claimNumber: this.claimNumber, currentCategory: this.currentCategory };
                  // Always push to invoices (UI list)
                  this.invoices.push(documentObj);
                  // Also push to cache for current flow
                  this.cachedDocuments[this.currentCategory].push(documentObj);
                } else {
                  this.invoices.push({ file: file, publicID: response.publicID });
                }
              } else if (bucket === "ONL-Photo") {

                if (this.isBundledClaim) {
                  let documentObj = { file: file, publicID: response.publicID, bucket: bucket, claimNumber: this.claimNumber, currentCategory: this.currentCategory };
                  // Always push to invoices (UI list)
                  this.photos.push(documentObj);
                  // Also push to cache for current flow
                  this.cachedDocuments[this.currentCategory].push(documentObj);
                } else {
                  this.photos.push({ file: file, publicID: response.publicID });
                }
              } else if (bucket === "ONL-Other") {

                if (this.isBundledClaim) {
                  let documentObj = { file: file, publicID: response.publicID, bucket: bucket, claimNumber: this.claimNumber, currentCategory: this.currentCategory };
                  // Always push to invoices (UI list)
                  this.others.push(documentObj);
                  // Also push to cache for current flow
                  this.cachedDocuments[this.currentCategory].push(documentObj);
                } else {
                  this.others.push({ file: file, publicID: response.publicID });
                }
              }
              this.updateDocumentStatus();
              setTimeout(() => {
                this.snackBar.openFromComponent(CustomToastComponent, {
                  data: { message: 'Your document has been successfully uploaded.' },
                  duration: 5000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top'
                });
              });
            } else {
              this.errorList.push({ filename: file.name, error: 'System error. Please try again' });
              console.log('Upload failed with response: ', response);
              this.uploadStatus.emit('incomplete');
            }
          }, error => {

            try {
              if (error.error.guideWireError) {
                if (error.error.guideWireError.includes('Claim number is null or empty')) {
                  this.errorList.push({ filename: file.name, error: 'Please select reason before uploading the document' });
                }
              } else {
                this.errorList.push({ filename: file.name, error: 'System error. Please try again' });
              }
            } catch {
              this.errorList.push({ filename: file.name, error: 'System error. Please try again' });
            }
            this.uploadStatus.emit({
              status: 'error',
              error: error
            });
          }
        );
      }, error => {
        this.errorList.push({ filename: file.name, error: 'System error. Please try again' });
        this.uploadStatus.emit({
          status: 'error',
          error: error
        });
      }
    );
  }

  updateDocumentStatus() {
    //others are optional unless the claim reason is damage/1
    if (this.invoices.length > 0 && (this.claimReason != '1' || this.photos.length > 0)) {
      this.uploadStatus.emit({
        status: 'complete',
        fileList: this.invoices.concat(this.photos).concat(this.others)
      });
      sessionStorage.setItem('documentUploadedFiles',
        JSON.stringify({
          invoices: this.invoices.map(i => {
            return {
              publicID: i.publicID,
              file: {
                name: i.file?.name
              }
            }
          }),
          photos: this.photos.map(p => {
            return {
              publicID: p.publicID,
              file: {
                name: p.file?.name
              }
            }
          }),
          others: this.others.map(o => {
            return {
              publicID: o.publicID,
              file: {
                name: o.file?.name
              }
            }
          })
        })
      );
    }
    else {
      this.uploadStatus.emit('incomplete');
    }
  }

  removeDocument(file: IDocumentDisplay, bucket?: string) {
    this.removeDocumentError = false;
    this.claimService.removeDocument(file).subscribe(
      data => {
        if (bucket == "ONL-Invoice") {
          this.invoices.splice(this.invoices.indexOf(file), 1);
        } else if (bucket == "ONL-Photo") {
          this.photos.splice(this.photos.indexOf(file), 1);
        } else if (bucket == "ONL-Other") {
          this.others.splice(this.others.indexOf(file), 1);
        }

        // Remove from cachedDocuments (if bundled claim)
        if (this.isBundledClaim && this.cachedDocuments && this.cachedDocuments[this.currentCategory]) {
          const cachedList = this.cachedDocuments[this.currentCategory];

          const index = cachedList.findIndex(
            doc => doc.publicID === file.publicID
          );
          if (index > -1) {
            cachedList.splice(index, 1);
          }
        }
        this.updateDocumentStatus();
      }, error => {
        this.removeDocumentError = true;
      }
    );
  }

  //When user tries to upload a document with special characters, sned it to GW with spaces replacing the special characters
  formatFileName(file) {
    let extension = file.name.substring(file.name.lastIndexOf('.'));
    let fileNameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.'));

    try {
      fileNameWithoutExtension = fileNameWithoutExtension.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, ' ');
      fileNameWithoutExtension = fileNameWithoutExtension.replace(ALL_SPECIAL_CHARACTERS, ' ');
      fileNameWithoutExtension = fileNameWithoutExtension.trim();
    } catch (e) { }

    return `${fileNameWithoutExtension}${extension}`;
  }

  openDialog(file: IDocumentDisplay): void {
    let dialogRef = this.dialog.open(DialogContentComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result == "confirm") {
        this.removeDocument(file);
      }
    });
  }

  clearDocumentErrors() {
    this.errorList = [];
  }

  currentCategory: any;
  setCurrentCategory(type) {
    // Change flow
    this.currentCategory = type;
    // Restore based on bucket type
    const categoryDocs = this.cachedDocuments[this.currentCategory] || [];
    this.invoices = categoryDocs.filter(doc => doc.bucket === 'ONL-Invoice');
    this.photos = categoryDocs.filter(doc => doc.bucket === 'ONL-Photo');
    this.others = categoryDocs.filter(doc => doc.bucket === 'ONL-Other');
  }

  setCategory(category: string) {
    this.currentCategory = category;
  }



}
